'use strict';

function _Paths() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.paths = {
    maintenance: '/account-maintenance',
    signup: {
      verify: '/member/dashboard/verify-account',
      create_profile: '/member/dashboard/profile-info',
      member_complete: '/member/dashboard/home/confirmation'
    }
  };

  this.init = function () {};
  this.initAllReady = function () {};
}